import {
  Aggregate,
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Inject,
  Page,
  QueryCellInfoEventArgs,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { useContext, useEffect, useState } from 'react';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import {
  AccumulationChartComponent,
  AccumulationDataLabel,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Category,
  ChartComponent,
  DataLabel,
  Legend,
  PieSeries,
  SeriesCollectionDirective,
  SeriesDirective,
  StackingColumnSeries,
  Tooltip,
} from '@syncfusion/ej2-react-charts';
import './cloud-discovery.css';
import moment from 'moment';
import {
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import { ThemeContext } from '../../context/theme.context';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import {
  CheckBoxSelection,
  MultiSelectComponent,
  Inject as DDInject,
  DropDownList,
} from '@syncfusion/ej2-react-dropdowns';
import GlobalSearch from '../../components/GlobalSearch';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import {
  getSystemConfig,
} from '../../services/GlobalFilter/GlobalFilterServices';
import { BsSearch } from 'react-icons/bs';
import { Query } from '@syncfusion/ej2-data';
import { GetKanbanColor } from '../../services/CloudScheduler/CloudSchedulerServices';
import GlobalGrid from '../../components/GlobalGrid';
import {
  getWorkRequestsPriorityAndStatusChart,
  updateOrderRequest,
} from '../../services/workrequest/workrequest';
import { SendRequest } from '../../utils/CreateRequest';
import { getBusinessLogicConfiguration } from '../../services/Dig/BusinessLogicConfiguration/BusinessLogicConfigurationServices';
import { getParamsDD } from '../../utils/GridParams';
import { GlobalMultiSelection } from '../../components/GlobalDropDown';
import { SyncFullProntoWorkRequests } from '../../services/ProntoServices/WorkRequestService/WorkRequestService';
import { AxiosResponse } from 'axios';
var enteredDat: DateRangePickerComponent = new DateRangePickerComponent({});
var gridForRequestDetail: GridComponent = new GridComponent({});
var current_query: string = '';
var theQueryStatuses = '';
var theQueryPrioritys = '';
var theQueryAsset = '';
var theQueryOutterAsset = '';
var theQueryType = '';
var theQueryResp = '';
var theQueryDate = '';
var theQuerySearch = '';
var resultLikeQuery = '';
var isRenderBegin: boolean = false;
var searchText: string = '';
var chipsValues: Array<any> = [];
var priorityFilterMSValue: Array<any> = [];
var assetFilterMSValue: Array<any> = [];
var statusFilterMSValue: Array<any> = [];
var typeFilterMSValue: Array<any> = [];
var respFilterMSValue: Array<any> = [];
var assetValue = '';
var enteredDate: Array<Date> | undefined = undefined;
var model: Array<any> = [];
var gridOrderRequest: GridComponent = new GridComponent({});
var current_page: number = 250 / 50;
const queryOfAsset = new Query().take(20);
interface IProps {
  outter_asset_code?: string;
  first_load_request: boolean;
}
const OrderRequest = ({ outter_asset_code, first_load_request }: IProps) => {

  const [PriorityColorData, setPriorityColorData] = useState(Array<any>());
  const [priorityAndStatusChartData, setPriorityAndStatusChartData] = useState(
    Array<any>()
  );
  const [prioritySumData, setPrioritySumData] = useState(Array<any>());
  const [gridForPriorityChartData, setGridForPriorityChartData] = useState(
    Array<any>()
  );
  const [p1, setP1] = useState(0);
  const [p2, setP2] = useState(0);
  const [p3, setP3] = useState(0);
  const [currentIcon, setCurrentIcon] = useState(<FaAngleDown size='14px' />);
  const [status, setStatus] = useState(false);
  const [allowRender, setAllowRender] = useState(false);
  const [statusFilterMSData, setStatusFilterMSData] = useState<Array<any>>([]);
  const [the_current_query, setThe_current_query] = useState('');
  const [signalOfLoad, setSignalOfLoad] = useState(false);
  var colorEl: Array<any> = [];
  const context = useContext(ThemeContext);
  const [selectedChip2, setSelectedChip2] = useState(Array<any>());
  var graphPriorityAndStatus: Array<any> = [];
  const [graphPriorityAndStatusTickets, setGraphPriorityAndStatusTickets] =
    useState(Array<any>());
  const templateSearch = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='order-request'
          autocomplete={'custom'}
          input={inputEnterPress.bind(this)}
          showClearButton
          placeholder='Search'
          onChange={(args: any) => {
            searchText = args.target.value;
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={context.isDarkMode ? '#eaeaea' : '#292525'}
            className={'searchIcon'}
            onClick={search.bind(this)}
          />
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (outter_asset_code) {
      buildQuery(true, '');
    }
  }, [outter_asset_code]);
  const template = () => {
    return (
      <div
        className='row md-6'
        style={{ alignSelf: 'end', display: 'flex', marginTop: 5 }}
      >
        <ChipListComponent
          id='chip-filter-cd'
          selection='Multiple'
          click={isChipClicked2}
          selectedChips={chipsValues}
        >
          <ChipsDirective>
            {PriorityColorData.map((el) => {
              return (
                <ChipDirective
                  text={`P${el.priority_code.trim()}`}
                  cssClass={`e-chip-textCD${el.priority_code.trim()}`}
                />
              );
            })}
          </ChipsDirective>
        </ChipListComponent>
      </div>
    );
  };
  const toolbarOptions: any = [
    // 'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    {
      text: 'Commit to ERP',
      tooltipText: '',
      id: 'commit',
    },
    {
      text: 'Reset Data',
      tooltipText: '',
      id: 'full-sync',
    },
    { template: template.bind(this), align: 'Right' },
    'ColumnChooser',
    'ExcelExport',
    { template: templateSearch, align: 'Right' },
  ];
  const isChipClicked2 = (e: any) => {
    if (e.selected) {
      selectedChip2.push(e.index + 1);
      chipsValues.push(e.index);
    } else {
      selectedChip2.splice(selectedChip2.indexOf(e.index + 1), 1);
      chipsValues.splice(chipsValues.indexOf(e.index), 1);
    }
    buildQuery(true, '');
  };
  useEffect(() => {
    isRenderBegin = true;
    const waitForColor = async () => {
      await getColor();
    };
    waitForColor();
    if (first_load_request) {
      loadingShow(true, 'process will take some time, please wait...');
      bussinesRule();
    }
    return () => {
      isRenderBegin = false;
    };
  }, []);
  const inputEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  };
  const bussinesRule = () => {
    getBusinessLogicConfiguration({ org_id: all_information.company_id })
      .then((el) => {
        current_query = '';
        el.data.map((elin: any) => {
          if (
            elin.target_table === 'uw_order_request' &&
            elin.component_name === 'Cloud Discovery'
          ) {
            current_query += elin.condition + ' and';
          }
        });
        current_query = current_query.replaceAll('=', '€');
        current_query = current_query.substring(
          0,
          current_query.lastIndexOf('and')
        );
        if (isRenderBegin) {
          buildQuery(true, '');
        }
      })
      .catch((er) => {
        //("Can't acces business logic parameter");
        Message.error("Can't acces business logic parameter");
        if (er.response) {
          Message.error(
            er.response.data +
            '\n' +
            er.response.status +
            '\n' +
            er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
        if (isRenderBegin) {
          buildQuery(true, '');
        }
      });
  };
  const colors = [
    '#003049',
    'green',
    '#D628228',
    '#F77F00',
    '#FCBF49',
    '#22799c',
    '#db6b16',
    '#81a391',
    '#8216db',
    '#8e18c9',
    '#f2eeb8',
    '#00b6ff',
    '#2a1140',
    '#d736e3',
    '#d1c40f',
    '#a971ad',
    '#6c5f73',
    '#e6e3e8',
    '#f097b0',
    '#73eb89',
  ];
  const generateColor = (index: number) => {
    return colors[index];
  };
  const getPriorityAndStatusChartData = (where: string) => {
    colorEl = PriorityColorData.length > 0 ? PriorityColorData : colorEl;
    graphPriorityAndStatus = [];
    let theTempGraphPriorityAndStatusTickets = graphPriorityAndStatusTickets;
    theTempGraphPriorityAndStatusTickets = [];
    getWorkRequestsPriorityAndStatusChart(where)
      .then((response) => {
        var counter: number = 0;
        let tempForOtherDataGridAndSummary: Array<any> = [];
        response.data.forEach((el: any, index: number) => {
          const foundIndex = theTempGraphPriorityAndStatusTickets.findIndex(
            (elin) => {
              return elin.value === el.priority?.trim().trimLeft().trimRight();
            }
          );
          if (foundIndex === -1 || foundIndex === undefined) {
            theTempGraphPriorityAndStatusTickets.push({
              y: `y${counter}`,
              value: el.priority?.trim().trimLeft().trimRight(),
              color: priorityColorForChart({
                request_priority_code: el.priority
                  ?.trim()
                  .trimLeft()
                  .trimRight(),
              }),
              colorFirstChart: generateColor(index),
            });
            counter++;
          }
        });
        response.data = response.data.map((el: any) => {
          return {
            ...el,
            status_code: statusCases({
              request_status_code: el.status_code,
            }),
          };
        });
        response.data.forEach((element: any) => {
          const foundIndex = graphPriorityAndStatus.findIndex((elin) => {
            return elin.status_code === element.status_code;
          });
          const paramName = theTempGraphPriorityAndStatusTickets.filter(
            (el) => el.value === element.priority?.trim().trimLeft().trimRight()
          );
          if (foundIndex != -1) {
            graphPriorityAndStatus[foundIndex][paramName[0].y] = element.y;
            tempForOtherDataGridAndSummary[foundIndex][
              `p${paramName[0].value}`
            ] = element.y;
            tempForOtherDataGridAndSummary[foundIndex]['total'] += element.y;
          } else {
            graphPriorityAndStatus.push({
              priority: element.priority,
              status_code: element.status_code,
              [paramName[0].y]: element.y,
            });
            tempForOtherDataGridAndSummary.push({
              p1: 0,
              p2: 0,
              p3: 0,
              status_code: element.status_code,
              [`p${paramName[0].value}`]: element.y,
              total: element.y,
            });
          }
        });
        var totalOfData = gridForRequestDetail?.getSummaryValues(
          { field: 'total', type: 'sum' },
          tempForOtherDataGridAndSummary
        ) as any;
        graphPriorityAndStatus = graphPriorityAndStatus.map(
          (elForPieChart, index) => {
            let totalStatus =
              Number(elForPieChart.y0 === undefined ? 0 : elForPieChart.y0) +
              Number(elForPieChart.y1 === undefined ? 0 : elForPieChart.y1) +
              Number(elForPieChart.y2 === undefined ? 0 : elForPieChart.y2);
            return {
              ...elForPieChart,
              yS: totalStatus,
              text: `${elForPieChart.status_code}: ${(
                (100 * totalStatus) /
                totalOfData
              ).toFixed(2)}% ${totalStatus}`,
              color: generateColor(index),
            };
          }
        );
        setGridForPriorityChartData(tempForOtherDataGridAndSummary);
        setPriorityAndStatusChartData(graphPriorityAndStatus);
        setGraphPriorityAndStatusTickets(theTempGraphPriorityAndStatusTickets);
      })
      .catch((er) => {
        if (er.response) {
          var array = Object.entries(er.response.data);
          Message.error(
            array.map((el) => {
              return el[1] + '\n';
            }) +
            '\n' +
            er.response.status +
            '\n' +
            er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
      });
  };
  const getColor = async () => {
    await GetKanbanColor(all_information?.company_id)
      .then((el) => {
        colorEl = el.data;
        setPriorityColorData(el.data);
        loadingShow(false);
      })
      .catch((e) => {
        console.log('Error: ');
      });
    return PriorityColorData;
  };
  const priorityColor = (args: any) => {
    let color = PriorityColorData.find(
      (x: any) => x.priority_code?.trim() === args.requestPriorityCode?.trim()
    )?.priority_color;
    return (
      <div
        style={{
          backgroundColor: color,
          borderRadius: 7,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: context.isDarkMode ? 'black' : 'white',
        }}
      >
        <span>{args.requestPriorityCode}</span>
      </div>
    );
  };
  const theTemplatePriority = priorityColor;
  const priorityColorForChart = (args: any) => {
    let color = '';
    if (Number(args.request_priority_code?.trim()) === 1) {
      color = colorEl[0]?.priority_color;
    } else if (Number(args.request_priority_code?.trim()) == 2) {
      color = colorEl[1]?.priority_color;
    } else if (Number(args.request_priority_code?.trim()) == 3) {
      color = colorEl[2]?.priority_color;
    } else if (Number(args.request_priority_code?.trim()) == 4) {
      color = colorEl[3]?.priority_color;
    }
    return color;
  };
  const search = () => {
    if (current_query !== '' || searchText !== '') {
      buildQuery(true, '');
    }
  };
  function statusTemplate(args: any) {
    var current_content = '';
    if (statusFilterMSData) {
      let theData = statusFilterMSData.filter(
        (el) => el.sys_tbl_code === args.requestStatusCode
      );
      if (theData.length > 0) {
        current_content =
          theData[0].sys_tbl_code + '-' + theData[0].sys_description;
      } else {
        if (args.requestStatusCode?.trim() === 'S') {
          current_content = 'S-ENTERED';
        } else if (args.requestStatusCode?.trim() === 'D') {
          current_content = 'D-DEFECTED';
        } else if (args.requestStatusCode?.trim() === 'I') {
          current_content = 'I-APPROVED';
        } else if (args.requestStatusCode?.trim() === 'H') {
          current_content = 'H-REJECT';
        } else if (args.requestStatusCode?.trim() === 'C') {
          current_content = 'C-COMPLETE';
        } else if (args.requestStatusCode?.trim() === 'N') {
          current_content = 'N-New Panding Review';
        } else {
          current_content = 'ERROR';
        }
      }
    }
    return <div>{current_content}</div>;
  }
  const statusCases = (args: any) => {
    var current_content = '';
    if (args.request_status_code?.trim() === 'S') {
      current_content = 'S-ENTERED';
    } else if (args.request_status_code?.trim() === 'D') {
      current_content = 'D-DEFECTED';
    } else if (args.request_status_code?.trim() === 'I') {
      current_content = 'I-APPROVED';
    } else if (args.request_status_code?.trim() === 'H') {
      current_content = 'H-REJECT';
    } else if (args.request_status_code?.trim() === 'C') {
      current_content = 'C-COMPLETE';
    } else {
      current_content = 'ERROR';
    }
    return current_content;
  };
  const expand = () => {
    var element = document.getElementById('expandable');
    if (status) {
      element?.classList.remove('layoutExpandCD');
      element?.classList.add('layoutCollapse');
      gridOrderRequest.height = 'calc(-629px + 100vh)';
    } else {
      element?.classList.remove('layoutCollapse');
      element?.classList.add('layoutExpandCD');
      gridOrderRequest.height = 'calc(-309px + 100vh)';
    }
    setStatus(!status);
    setCurrentIcon(
      status ? <FaAngleDown size='14px' /> : <FaAngleUp size='14px' />
    );
    setAllowRender(true);
  };
  const ApplyFilter = () => {
    colorEl = PriorityColorData.length > 0 ? PriorityColorData : colorEl;
    buildQuery(true, '');
  };
  const clearFilter = () => {
    statusFilterMSValue = [];
    typeFilterMSValue = [];
    respFilterMSValue = [];
    priorityFilterMSValue = [];
    assetValue = '';
    enteredDate = [];
    assetFilterMSValue = [];
    buildQuery(true, '');
  };
  const StatusMultiSelect = () => {
    return (
      <div>
        <GlobalMultiSelection
          field={{ value: 'value', text: 'alias' }}
          id='ordersFilterMultiStatus'
          url='global-filter?where=order-request$status$isEnabled€1'
          placeHolder='Select a Status'
          value={statusFilterMSValue}
          onChange={(e: any) => {
            statusFilterMSValue = e.value;
          }}
        />
      </div>
    );
  };
  const PriorityMultiSelect = () => {
    return (
      <>
        <GlobalMultiSelection
          field={{ value: 'sys_tbl_code', text: 'sys_description' }}
          id='orderReqFilterMultiPriority'
          url='system-config?where=N1'
          placeHolder='Select a Priority'
          value={priorityFilterMSValue}
          onChange={(e: any) => {
            priorityFilterMSValue = e.value;
          }}
        />
      </>
    );
  };
  const AssetInput = () => {
    return (
      <>
        <GlobalMultiSelection
          query={queryOfAsset}
          field={{ text: 'assetCode', value: 'assetCode' }}
          placeHolder='Select a Asset'
          id='orderRqFilterMultiAsset'
          url='assets/search'
          value={assetFilterMSValue}
          allowFiltering={true}
          onChange={(e: any) => {
            assetFilterMSValue = e.value;
          }}
        />
      </>
    );
  };
  const TypeInput = () => {
    return (
      <>
        <GlobalMultiSelection
          field={{ value: 'sys_tbl_code', text: 'sys_description' }}
          id='orderReqFilterMultiType'
          url='system-config?where=P3'
          placeHolder='Select a Type'
          value={typeFilterMSValue}
          onChange={(e: any) => {
            typeFilterMSValue = e.value;
          }}
        />
      </>
    );
  };
  const RespInput = () => {
    return (
      <>
        <GlobalMultiSelection
          field={{ value: 'sys_tbl_code', text: 'sys_description' }}
          id='orderReqFilterMultiResp'
          url='system-config?where=P2'
          placeHolder='Select a Resp'
          onChange={(e: any) => {
            respFilterMSValue = e.value;
          }}
          value={respFilterMSValue}
        />
      </>
    );
  };
  const buildQuery = (clearRequest: boolean, additionalQuery: string) => {
    current_query = current_query.trimEnd();
    current_query = current_query.replace(theQueryPrioritys, '');
    current_query = current_query.replace(theQueryAsset, '');
    current_query = current_query.replace(theQueryOutterAsset, '');
    current_query = current_query.replace(theQueryType, '');
    current_query = current_query.replace(theQueryDate, '');
    current_query = current_query.replace(theQueryResp, '');
    current_query = current_query.replace(theQueryStatuses, '');
    current_query = current_query.replace(theQuerySearch, '');
    theQueryPrioritys = '';
    theQueryAsset = '';
    theQueryDate = '';
    theQueryResp = '';
    theQueryStatuses = '';
    theQueryType = '';
    theQuerySearch = '';
    var thePrioritysMerged = selectedChip2.concat(priorityFilterMSValue);
    var thePurePrioritys = [...new Set(thePrioritysMerged)];
    var thePrioritys = thePurePrioritys?.toString();
    var theStatuses = statusFilterMSValue?.toString();
    var theTypes = typeFilterMSValue?.toString();
    var theResp = respFilterMSValue?.toString();
    var theAssets = assetFilterMSValue?.toString();
    var theDate = enteredDate as Date[];
    var o_asset_code = outter_asset_code;
    if (thePrioritys !== '' && thePrioritys !== undefined) {
      if (current_query !== '') {
        theQueryPrioritys = addToQuery(
          'request_priority_code',
          'in',
          'andWhere',
          thePrioritys?.toString(),
          theQueryPrioritys
        );
      } else {
        theQueryPrioritys = addToQuery(
          'request_priority_code',
          'in',
          'where',
          thePrioritys?.toString(),
          theQueryPrioritys
        );
      }
    }
    if (theStatuses !== '' && theStatuses !== undefined) {
      if (current_query !== '') {
        theQueryStatuses = addToQuery(
          'request_status_code',
          'in',
          'andWhere',
          theStatuses?.toString(),
          theQueryStatuses
        );
      } else {
        theQueryStatuses = addToQuery(
          'request_status_code',
          'in',
          'where',
          theStatuses?.toString(),
          theQueryStatuses
        );
      }
    }
    if (resultLikeQuery !== '') {
      if (current_query !== '') {
        theQuerySearch = ' and (' + resultLikeQuery + ')';
        current_query = current_query + theQuerySearch;
      } else {
        theQuerySearch = ' (' + resultLikeQuery + ')';
        current_query = current_query + theQuerySearch;
      }
    }
    if (theAssets !== '' && theAssets !== undefined) {
      if (current_query !== '') {
        theQueryAsset = addToQuery(
          'asset_code',
          'in',
          'andWhere',
          theAssets?.toString(),
          theQueryAsset
        );
      } else {
        theQueryAsset = addToQuery(
          'asset_code',
          'in',
          'where',
          theAssets?.toString(),
          theQueryAsset
        );
      }
    }
    if (theTypes !== '' && theTypes !== undefined) {
      if (current_query !== '') {
        theQueryType = addToQuery(
          'request_type_code',
          'in',
          'andWhere',
          theTypes?.toString(),
          theQueryType
        );
      } else {
        theQueryType = addToQuery(
          'request_type_code',
          'in',
          'where',
          theTypes?.toString(),
          theQueryType
        );
      }
    }
    if (theResp !== '' && theResp !== undefined) {
      if (current_query !== '') {
        theQueryResp = addToQuery(
          'resp_code',
          'in',
          'andWhere',
          theResp?.toString(),
          theQueryResp
        );
      } else {
        theQueryResp = addToQuery(
          'resp_code',
          'in',
          'where',
          theResp?.toString(),
          theQueryResp
        );
      }
    }
    if (enteredDate) {
      if (enteredDate.length > 0 && enteredDat?.value !== null) {
        if (current_query !== '') {
          var start_date = moment(theDate[0]).format('yyyy-MM-DD');
          var end_date = moment(theDate[1]).format('yyyy-MM-DD');
          theQueryDate = addToQuery(
            'entered_date',
            '>',
            'andWhere',
            start_date,
            theQueryDate
          );
          theQueryDate += addToQuery(
            'entered_date',
            '<',
            'andWhere',
            end_date,
            theQueryDate
          );
        } else {
          var start_date = moment(theDate[0]).format('yyyy-MM-DD');
          var end_date = moment(theDate[1]).format('yyyy-MM-DD');
          theQueryDate = addToQuery(
            'entered_date',
            '>',
            'where',
            start_date,
            theQueryDate
          );
          theQueryDate += addToQuery(
            'entered_date',
            '<',
            'andWhere',
            end_date,
            theQueryDate
          );
        }
      }
    }
    if (o_asset_code !== '' && o_asset_code !== undefined) {
      if (current_query !== '') {
        theQueryOutterAsset = addToQuery(
          'asset_code',
          'in',
          'andWhere',
          o_asset_code?.trim(),
          theQueryOutterAsset
        );
      } else {
        theQueryOutterAsset = addToQuery(
          'asset_code',
          'in',
          'where',
          o_asset_code?.trim(),
          theQueryOutterAsset
        );
      }
    }
    if (searchText !== '') {
      theQuerySearch = '$' + searchText;
      current_query = current_query + theQuerySearch;
    }
    if (clearRequest) {
      model = [];
    }
    getPriorityAndStatusChartData('1$20$' + current_query + '$');
    setSignalOfLoad(true);
    setThe_current_query(current_query + ' ' + additionalQuery);
  };
  const addToQuery = (
    field: string,
    c: string,
    type: string,
    v: string,
    the_current_query: string
  ) => {
    the_current_query = JSON.stringify({
      f: field,
      c: c,
      t: type,
      v: v,
    });
    the_current_query += '?';
    current_query += the_current_query;
    return the_current_query;
  };
  const dateRangeOnChange = (e: any) => {
    enteredDate = e.value;
  };
  const EnteredInput = () => {
    return (
      <div>
        <DateRangePickerComponent
          ref={(scope: DateRangePickerComponent) => {
            enteredDat = scope;
          }}
          placeholder='Entered Date'
          format={'dd/MM/yyyy'}
          enabled={true}
          showClearButton={true}
          onChange={dateRangeOnChange.bind(this)}
          value={enteredDate}
          delayUpdate={true}
        ></DateRangePickerComponent>
      </div>
    );
  };
  useEffect(() => {
    $('#order-request').val(searchText);
    PriorityColorData?.map((elCol: any) => {
      $(`.e-chip-textCD${elCol.priority_code?.trim()}`).css(
        'background-color',
        `${elCol?.priority_color}`
      );
      var el = document.getElementsByClassName(
        `e-chip-textCD${elCol.priority_code?.trim()}`
      )[0] as any;
      if (el) {
        el.style.backgroundColor = elCol?.priority_color;
      }
    });
  });
  const dataBound = () => {
    $('.cloud-discovery-order-request .e-grid .e-headercell:nth-child(2)').css(
      'background-color',
      `${PriorityColorData[0]?.priority_color}`
    );
    $('.cloud-discovery-order-request .e-grid .e-headercell:nth-child(3)').css(
      'background-color',
      `${PriorityColorData[1]?.priority_color}`
    );
    $('.cloud-discovery-order-request .e-grid .e-headercell:nth-child(4)').css(
      'background-color',
      `${PriorityColorData[2]?.priority_color}`
    );
    var p1 = gridForRequestDetail?.getSummaryValues(
      { field: 'p1', type: 'sum' },
      gridForPriorityChartData
    ) as any;
    var p2 = gridForRequestDetail?.getSummaryValues(
      { field: 'p2', type: 'sum' },
      gridForPriorityChartData
    ) as any;
    var p3 = gridForRequestDetail?.getSummaryValues(
      { field: 'p3', type: 'sum' },
      gridForPriorityChartData
    ) as any;
    var total = gridForRequestDetail?.getSummaryValues(
      { field: 'total', type: 'sum' },
      gridForPriorityChartData
    ) as any;
    let datas = [
      {
        p_code: 'P1',
        y: p1,
        color: PriorityColorData[0]?.priority_color,
        text: `P1: ${((100 * p1) / total).toFixed(2)}% ${p1}`,
      },
      {
        p_code: 'P2',
        y: p2,
        color: PriorityColorData[1]?.priority_color,
        text: `P2: ${((100 * p2) / total).toFixed(2)}% ${p2}`,
      },
      {
        p_code: 'P3',
        y: p3,
        color: PriorityColorData[2]?.priority_color,
        text: `P3: ${((100 * p3) / total).toFixed(2)}% ${p3}`,
      },
    ];
    var searchEle :any = gridForRequestDetail?.element.querySelector(
      '#' + gridForRequestDetail.element.id + '_searchbar'
    );
    if (searchEle) {
      searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
    }
    setP1(p1);
    setP2(p2);
    setP3(p3);
    setPrioritySumData(datas);
  };
  const column = [
    {
      field: 'requestId',
      headerText: 'Request ID',
      textAlign: 'Left',
      width: 50,
      isPrimaryKey: true,
      visible: false,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'isEffected',
      textAlign: 'Left',
      width: 50,
      visible: false,
      clipMode: 'EllipsisWithTooltip',
      type: 'boolean',
    },
    {
      field: 'requestPriorityCode',
      headerText: 'Priority',
      textAlign: 'Left',
      width: 50,
      template: theTemplatePriority,
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
    },
    {
      field: 'assetCode',
      headerText: 'Asset Number',
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
    },
    {
      field: 'requestCode',
      headerText: 'Request Number',
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
    },
    {
      field: 'description',
      headerText: 'Job Detail',
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      type: 'string',
    },
    {
      field: 'requestStatusCode',
      headerText: 'Status Description',
      textAlign: 'Left',
      template: statusTemplate.bind(this),
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
      edit: getParamsDD(
        { value: 'value', text: 'alias' },
        'requestStatusCode',
        'global-filter?where=work-request$status$isEnabled€1',
        true
      ),
      allowEditing: true,
    },
    {
      field: 'requestTypeCode',
      headerText: 'Type',
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      edit: getParamsDD(
        { value: 'sys_tbl_code', text: 'sys_description' },
        'requestTypeCode',
        'system-config?where=P3',
        true
      ),
      type: 'string',
    },
    {
      field: 'enteredDate',
      headerText: 'Entered Date',
      textAlign: 'Left',
      format: 'dd/MM/yyyy',
      type: 'date',
      clipMode: 'EllipsisWithTooltip',
      visible: false,
      allowEditing: true,
      editType: 'datetimepickeredit',
    },
    {
      field: 'requestedDate',
      headerText: 'Requested Date',
      format: 'dd/MM/yyyy',
      type: 'date',
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      editType: 'datetimepickeredit',
    },
    {
      field: 'requestedBy',
      headerText: 'Requested By',
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
      allowEditing: true,
    },
    {
      field: 'sectionCode',
      headerText: 'Section',
      textAlign: 'Left',
      allowEditing: true,
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
      edit: getParamsDD(
        { value: 'sys_tbl_code', text: 'sys_description' },
        'sectionCode',
        'system-config?where=N4',
        true
      ),
    },
    {
      field: 'requestApprovedDate',
      headerText: 'Request Approved Date',
      format: 'dd/MM/yyyy',
      allowEditing: true,
      type: 'date',
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      editType: 'datetimepickeredit',
    },
    {
      field: 'requestSortDate',
      headerText: 'Request Sort Date',
      format: 'dd/MM/yyyy',
      allowEditing: true,
      type: 'date',
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      editType: 'datetimepickeredit',
    },
    {
      field: 'requestApprovedBy',
      headerText: 'Request Approved By',
      allowEditing: true,
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
    },
    {
      field: 'requestCompletionDate',
      headerText: 'Request Completion Date',
      format: 'dd/MM/yyyy',
      type: 'date',
      allowEditing: true,
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      editType: 'datetimepickeredit',
    },
    {
      field: 'respCode',
      headerText: 'Resp Code',
      textAlign: 'Left',
      allowEditing: true,
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
    },
    {
      field: 'reference',
      headerText: 'Reference',
      allowEditing: true,
      textAlign: 'Left',
      clipMode: 'EllipsisWithTooltip',
      type: 'string',
    },
  ];
  const toolbarClickExtends = async(args: any) => {
    if (args.item.id === 'full-sync') {
      await SyncFullProntoWorkRequests()
      .then((result: AxiosResponse) => {
        if (result.status == 200) {
          Message.success('Synced successfully...');
        }
      })
      .catch((err: any) => {
        Message.error('Sync failed!!!');
      });
    }
    if (args.item.id === 'commit') {
      if (gridOrderRequest.getSelectedRecords().length > 0) {
        var theQuery = '';
        let theDatas = gridOrderRequest.getSelectedRecords();
        theDatas.map((theData: any) => {
          theQuery += `update pltjobh set
            pltjobh.plt_job_no='${theData.requestCode}'
          , pltjobh.plt_job_type='${theData.requestTypeCode}'
          , pltjobh.plt_job_status='${theData.requestStatusCode}'
          , pltjobh.plt_job_priority='${theData.requestPriorityCode}'
          , pltjobh.plant_no='${theData.assetCode}'
          , pltjobh.job_plant_dept='${theData.departmentCode}'
          , pltjobh.job_section_code='${theData.sectionCode}'
          , pltjobh.reference_field='${theData.reference}'
          , pltjobh.job_approved_by='${theData.requestApprovedBy}'
          , pltjobh.next_action_by='${theData.respCode}'
          , pltjobh.planned_by_code='${theData.requestedBy}'
          , pltjobh.labour_type_1='${theData.labourType_1}'
          , pltjobh.labour_type_2='${theData.labourType_2}'
          , pltjobh.labour_type_3='${theData.labourType_3}'
          , pltjobh.labour_type_4='${theData.labourType_4}'
          , pltjobh.est_hours_1='${theData.labEstHours_1}'
          , pltjobh.est_hours_2='${theData.labEstHours_2}'
          , pltjobh.est_hours_3='${theData.labEstHours_3}'
          , pltjobh.est_hours_4='${theData.labEstHours_4}'
          , pltjobh.plt_job_kit_code='${theData.orderCode}'
          , pltjobh.reject_reason='${theData.rejectNote}'
          where row_id=${theData.prontoRowId}; `;
        });
        SendRequest(theQuery,"", calbackFromQueryRequest);
      }
    }
  };
  const calbackFromQueryRequest = (args: any) => {
    if (gridOrderRequest.getSelectedRecords().length > 0) {
      let theDatas = gridOrderRequest.getSelectedRecords();
      theDatas = theDatas.map((theData: any) => {
        return { ...theData, isEffected: false };
      });
      updateOrderRequest(theDatas)
        .then((res) => {
          setSignalOfLoad(false);
          Message.success('Success');
          buildQuery(false, '$');
        })
        .catch((er) => {
          Message.error('Error occured');
        });
    }
  };
  const gueryCellInfo = (args: QueryCellInfoEventArgs) => {
    if (
      args.column &&
      args.column.type === 'checkbox' &&
      args.data &&
      args.cell
    ) {
      let theData = args.data as any;
      if (theData) {
        let isEffected = theData.isEffected;
        let theCurrenColor = 'tranparent';
        if (isEffected) {
          theCurrenColor = '#8ECDDD';
        }
        args.cell.setAttribute('style', `background-color:${theCurrenColor};`);
      }
    }
  };
  return (
    <div className='main-content-order-request'>
      <div className='main' onClick={expand.bind(this)}>
        {currentIcon}
      </div>
      <div id='expandable' className='layout'>
        {allowRender ? (
          <div
            className='row'
            style={{
              overflow: 'scroll',
              width: '100%',
              height: '100%',
            }}
          >
            <div className='col-lg-4'>
              <div
                className=''
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <h4>{Number(p1) + Number(p2) + Number(p3)}</h4>
                <span className=''>Total Number of Work Requests</span>
                <div className='flex flex-row'>
                  <div className='calculate-number p1'>
                    <h4
                      style={{
                        color: `${PriorityColorData[0]?.priority_color}`,
                      }}
                      className='number'
                    >
                      {p1}
                    </h4>
                  </div>
                  <div className='calculate-number p2'>
                    <h4
                      style={{
                        color: `${PriorityColorData[1]?.priority_color}`,
                      }}
                      className='number'
                    >
                      {p2}
                    </h4>
                  </div>
                  <div className='calculate-number p3'>
                    <h4
                      style={{
                        color: `${PriorityColorData[2]?.priority_color}`,
                      }}
                      className='number'
                    >
                      {p3}
                    </h4>
                  </div>
                </div>
              </div>
              <div className='cloud-discovery-order-request'>
                <GridComponent
                  ref={(grid: GridComponent) => (gridForRequestDetail = grid)}
                  dataSource={gridForPriorityChartData}
                  height='180px'
                  width={'100%'}
                  dataBound={dataBound}
                  gridLines='Both'
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field='status_code'
                      headerText='Status'
                      textAlign='Left'
                      width={'100px'}
                    />
                    <ColumnDirective
                      field='p1'
                      headerText='1'
                      textAlign='Center'
                    />
                    <ColumnDirective
                      field='p2'
                      headerText='2'
                      textAlign='Center'
                    />
                    <ColumnDirective
                      field='p3'
                      headerText='3'
                      textAlign='Center'
                    />
                    <ColumnDirective
                      field='total'
                      headerText='Total'
                      textAlign='Left'
                    />
                  </ColumnsDirective>
                  <Inject
                    services={[
                      Edit,
                      Toolbar,
                      Filter,
                      Page,
                      ColumnChooser,
                      ExcelExport,
                      ColumnMenu,
                      Resize,
                      Aggregate,
                    ]}
                  />
                </GridComponent>
              </div>
            </div>
            <div className='col-lg-4'>
              <ChartComponent
                id='charts'
                style={{ textAlign: 'center' }}
                title='# of Maintenance Requests by Priority and Status'
                primaryXAxis={{
                  majorGridLines: { width: 0 },
                  minorGridLines: { width: 0 },
                  majorTickLines: { width: 0 },
                  minorTickLines: { width: 0 },
                  interval: 1,
                  lineStyle: { width: 0 },
                  labelIntersectAction: 'Rotate45',
                  labelStyle: {
                    textOverflow: 'Wrap',
                    color: context.isDarkMode ? 'rgb(234,234,234)' : '#15202B',
                    size: '12px',
                    fontFamily:
                      'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                    fontStyle: 'normal',
                    fontWeight: '400',
                  },
                  valueType: 'Category',
                }}
                primaryYAxis={{
                  lineStyle: { width: 0 },
                  majorTickLines: { width: 1 },
                  majorGridLines: { width: 0 },
                  minorGridLines: { width: 1 },
                  minorTickLines: { width: 1 },
                  labelStyle: {
                    size: '8px',
                  },
                  labelFormat: '{value}',
                }}
                background='none'
                height={'300px'}
                width={'100%'}
                chartArea={{ border: { width: 0 } }}
                titleStyle={{
                  color: context.isDarkMode ? '#FFFFFF' : '#15202B',
                  size: '12px',
                  fontFamily:
                    'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                  fontStyle: 'normal',
                  fontWeight: '400',
                }}
                legendSettings={{
                  textStyle: {
                    color: context.isDarkMode ? '#EAEAEA' : '#15202B',
                    size: '8px',
                    textOverflow: 'Wrap',
                  },
                  position: 'Top',
                  description: 'sdf',
                  title: 'Priority',
                  titlePosition: 'Left',
                  titleStyle: {
                    color: context.isDarkMode ? '#FFFFFF' : '#15202B',
                    size: '12px',
                    fontFamily:
                      'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                    fontStyle: 'normal',
                    fontWeight: '400',
                  },
                }}
                tooltip={{
                  enable: true,
                  format:
                    '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
                }}
              >
                <Inject
                  services={[
                    StackingColumnSeries,
                    Legend,
                    Tooltip,
                    DataLabel,
                    Category,
                  ]}
                />
                <SeriesCollectionDirective>
                  {graphPriorityAndStatusTickets.map(
                    (el: any, index: number) => {
                      return (
                        <SeriesDirective
                          key={Math.random()}
                          dataSource={priorityAndStatusChartData}
                          xName={`status_code`}
                          yName={`y${index}`}
                          name={el.value}
                          type='StackingColumn'
                          fill={el.color}
                        ></SeriesDirective>
                      );
                    }
                  )}
                </SeriesCollectionDirective>
              </ChartComponent>
            </div>
            <div className='col-lg-2'>
              <AccumulationChartComponent
                enableSmartLabels={true}
                height={'300px'}
                width={'100%'}
                background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                titleStyle={{
                  color: context.isDarkMode ? '#FFFFFF' : '#15202B',
                  size: '12px',
                  fontFamily:
                    'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                  fontStyle: 'normal',
                  fontWeight: '400',
                }}
                tooltip={{
                  enable: true,
                  format:
                    '<b>${point.x}</b><br>Browser Share: <b>${point.y}%</b>',
                }}
                title={'# of Maintenance Requests by Status'}
                enableBorderOnMouseMove={false}
                legendSettings={{ visible: false }}
              >
                <Inject services={[PieSeries, AccumulationDataLabel]} />
                <AccumulationSeriesCollectionDirective>
                  <AccumulationSeriesDirective
                    dataSource={priorityAndStatusChartData}
                    xName='status_code'
                    yName='yS'
                    innerRadius='70%'
                    startAngle={0}
                    endAngle={360}
                    radius='55%'
                    explode={true}
                    explodeOffset='10%'
                    explodeIndex={0}
                    pointColorMapping='color'
                    dataLabel={{
                      visible: true,
                      position: 'Outside',
                      name: 'text',
                      font: {
                        fontWeight: '300',
                        textOverflow: 'Wrap',
                        size: '9px',
                        fontFamily: 'arial',
                        fontStyle: 'normal',
                      },
                    }}
                  ></AccumulationSeriesDirective>
                </AccumulationSeriesCollectionDirective>
              </AccumulationChartComponent>
            </div>
            <div className='col-lg-2'>
              <AccumulationChartComponent
                enableSmartLabels={true}
                height={'300px'}
                width={'100%'}
                background={context.isDarkMode ? '#15202B' : '#EAEAEA'}
                tooltip={{
                  enable: true,
                  format:
                    '<b>${point.x}</b><br>Browser Share: <b>${point.y}%</b>',
                }}
                title={'% of Maintenance Requests by Priority'}
                titleStyle={{
                  color: context.isDarkMode ? '#FFFFFF' : '#15202B',
                  size: '12px',
                  fontFamily:
                    'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                  fontStyle: 'normal',
                  fontWeight: '400',
                }}
                enableBorderOnMouseMove={false}
                legendSettings={{ visible: false }}
              >
                <Inject services={[PieSeries, AccumulationDataLabel]} />
                <AccumulationSeriesCollectionDirective>
                  <AccumulationSeriesDirective
                    dataSource={prioritySumData}
                    xName='p_code'
                    yName='y'
                    innerRadius='70%'
                    pointColorMapping='color'
                    startAngle={0}
                    endAngle={360}
                    radius='55%'
                    explode={true}
                    explodeOffset='10%'
                    explodeIndex={0}
                    dataLabel={{
                      visible: true,
                      position: 'Outside',
                      name: 'text',
                      font: {
                        textOverflow: 'Wrap',
                        color: context.isDarkMode
                          ? 'rgb(234,234,234)'
                          : '#15202B',
                        size: '9px',
                        fontFamily: 'arial',
                        fontStyle: 'normal',
                        fontWeight: '500',
                      },
                    }}
                  ></AccumulationSeriesDirective>
                </AccumulationSeriesCollectionDirective>
              </AccumulationChartComponent>
            </div>
          </div>
        ) : null}
      </div>
      <GlobalSearch
        id='cloud-discovery-order-request'
        height={'416px'}
        applyFilter={ApplyFilter.bind(this)}
        clearFilter={clearFilter.bind(this)}
        Component1={PriorityMultiSelect.bind(this)}
        Component2={StatusMultiSelect.bind(this)}
        Component3={AssetInput.bind(this)}
        Component4={TypeInput.bind(this)}
        Component5={RespInput.bind(this)}
        Component6={EnteredInput.bind(this)}
      />
      <GlobalGrid
        id='order-request-globalgrid'
        columns={column}
        allowCheckBox={true}
        query={the_current_query}
        allowMultiSelection={true}
        get_query={'order-request'}
        queryCellInfo={gueryCellInfo}
        height={'calc(-309px + 100vh)'}
        toolbarOptions={toolbarOptions}
        edit_query={'order-request/update'}
        delete_query={'order-request/delete'}
        additionalCrudParams={{ isEffected: 1 }}
        additinalToolbarClick={toolbarClickExtends.bind(this)}
        gridRef={(g: GridComponent) => (gridOrderRequest = g)}
        signalOfLoad={signalOfLoad ? signalOfLoad : first_load_request}
      />
    </div>
  );
};
export default OrderRequest;
